import UploadFile from '../../../components/upload-file/UploadFile';

const AddMediaPage = () => {
  return <UploadFile />;
};

export default AddMediaPage;
